/* VELSENOR v23: only the most visible film plays; explicit play always wins. */
(() => {
  'use strict';
  const ready = callback => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', callback, {once:true}) : callback();
  ready(() => {
    const selector = '[data-voralis-film],[data-lc-cinematic-video],[data-lc-hero-film],video.ambient-video,.video-story video';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = Boolean(navigator.connection && navigator.connection.saveData);
    const records = new Map();
    let active = null;
    let manuallySelected = null;
    if (saveData) document.documentElement.classList.add('lc-save-data');

    const setControl = (video, playing) => {
      const record = records.get(video);
      if (!record) return;
      video.dataset.playing = String(playing);
      if (!record.button) return;
      record.button.classList.toggle('is-playing', playing);
      record.button.setAttribute('aria-pressed', String(playing));
      const verb = playing ? (record.button.dataset.labelPause || 'Pause film') : (record.button.dataset.labelPlay || 'Play film');
      record.button.setAttribute('aria-label', verb + (record.button.dataset.filmLabel ? ` — ${record.button.dataset.filmLabel}` : ''));
    };
    const pause = video => {video.pause(); setControl(video, false);};
    const play = video => {
      if (document.hidden) return;
      records.forEach((_, other) => {if (other !== video && !other.paused) pause(other);});
      active = video;
      if (!video.getAttribute('src') && !video.querySelector('source') && video.dataset.src) {
        video.src = video.dataset.src;
        video.load();
      }
      video.muted = true;
      video.playsInline = true;
      if (!video.paused) {setControl(video, true); return;}
      const pending = video.play();
      if (pending && pending.then) pending.then(() => {
        if (active !== video || document.hidden) pause(video);
        else setControl(video, !video.paused);
      }).catch(() => setControl(video, false));
    };
    const evaluate = () => {
      if (document.hidden) {records.forEach((_, video) => pause(video)); active = null; return;}
      if (manuallySelected) {
        const manual = records.get(manuallySelected);
        if (manual && manual.ratio > .05) {play(manuallySelected); return;}
        manuallySelected = null;
      }
      if (reduced.matches || saveData) {records.forEach((_, video) => pause(video)); active = null; return;}
      let best = null;
      let score = 0;
      records.forEach((record, video) => {
        if (record.ratio >= .15 && record.area > score) {best = video; score = record.area;}
      });
      if (!best || records.get(best).manuallyPaused) {
        records.forEach((_, video) => pause(video)); active = null; return;
      }
      play(best);
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const record = records.get(entry.target);
        if (!record) return;
        record.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
        record.area = entry.isIntersecting ? entry.intersectionRect.width * entry.intersectionRect.height : 0;
      });
      evaluate();
    }, {threshold:[0,.05,.15,.3,.5,.75,1]});

    const register = scope => {
      scope.querySelectorAll(selector).forEach(video => {
        if (records.has(video)) return;
        const panel = video.closest('[data-voralis-film-panel],[data-lc-cinematic-panel],.hero');
        const button = panel && panel.querySelector('[data-voralis-film-toggle],[data-lc-film-toggle]');
        const record = {button, ratio:0, area:0, manuallyPaused:false};
        records.set(video, record);
        video.removeAttribute('autoplay');
        video.muted = true;
        pause(video);
        observer.observe(video);
        if (button) button.addEventListener('click', () => {
          if (video.paused) {record.manuallyPaused = false; manuallySelected = video; play(video);}
          else {record.manuallyPaused = true; manuallySelected = null; pause(video); if (active === video) active = null;}
        });
        video.addEventListener('pause', () => setControl(video, false));
        video.addEventListener('play', () => setControl(video, true));
        video.addEventListener('error', () => {video.dataset.mediaError = 'true'; setControl(video, false);});
      });
    };
    register(document);
    document.addEventListener('visibilitychange', evaluate);
    if (reduced.addEventListener) reduced.addEventListener('change', evaluate);
    document.addEventListener('shopify:section:load', event => register(event.target));
    document.addEventListener('shopify:section:unload', event => {
      records.forEach((_, video) => {
        if (!event.target.contains(video)) return;
        pause(video); observer.unobserve(video); records.delete(video);
        if (active === video) active = null;
        if (manuallySelected === video) manuallySelected = null;
      });
      evaluate();
    });
    window.addEventListener('pagehide', () => records.forEach((_, video) => pause(video)));
    window.addEventListener('pageshow', evaluate);
  });
})();
